import { useMutation } from 'react-query';
import api from '@/apis/utils';
import { AxiosError } from 'axios';
import GlobalAlert from '@/components/GlobalAlert';
import { getErrorMessage } from '@/utils/error';

/** [주소] 위경도 조회 */
const useCoordsQuery = () => {
  const getCoordsMutation = useMutation(
    (address: string) => api.getCoords(address),
    {
      onError: (err: AxiosError) => {
        GlobalAlert.show({ title: getErrorMessage(err) });
      }
    }
  );

  return { getCoordsMutation };
};

export default useCoordsQuery;
